import getDay from "date-fns/get_day";
import format from "date-fns/format";
import deLocale from "date-fns/locale/de";

export default class WorkdayModel {
    constructor(entries) {
        this.entries = entries;
    }

    get date() {
        if(this.entries === undefined || this.entries.length === 0) {
            return undefined;
        }

        return this.entries[0].begin;
    }

    get day() {
        if(this.entries === undefined || this.entries.length === 0) {
            return undefined;
        }

        return getDay(this.entries[0].begin);
    }

    get dayFormat() {
        if(this.entries === undefined || this.entries.length === 0) {
            return undefined;
        }

        return format(this.entries[0].begin, "dddd", {locale: deLocale});
    }
}



// WEBPACK FOOTER //
// ./src/models/workday.js